import React from 'react';
import { withLocalization } from "../locales";
import Menu from "./model/Menu";
import { useIntl } from "react-intl";
import { Grid } from '@material-ui/core';
import CategoryView from './Util/CategoryView';

interface Props {
    menu: Menu;
}

export function MenuView(props: Props) {
    return withLocalization(
        <MenuViewBase {...props} />);
};


function MenuViewBase({ menu }: Props) {
    const intl = useIntl();
    const menuForView = menu.getForView(intl);
    return (
        <Grid container>
            {menuForView.getCategories().map((category, idx) => (
                <Grid item xs={12} key={`menu-category-${idx}`}>
                    <CategoryView category={category} />
                </Grid>
            ))}
        </Grid>
    );
}